import type { OnboardingWorkMode } from "@/components/onboarding/OnboardingWorkModeChoice"

/** Onboarding step 01's answer, saved so a returning visitor resumes on the same path. */
export const WORK_MODE_KEY = "humblytics:onboarding-work-mode:v1"

export function readWorkMode(): OnboardingWorkMode | null {
  try {
    const v = localStorage.getItem(WORK_MODE_KEY)
    return v === "agent" || v === "app" ? v : null
  } catch {
    return null
  }
}
